import { fetchAPI } from "./utils";

export interface AppUser {
    id: string;
    email: string;
    firstname: string;
    lastname: string;
    phone: string | null;
    type: string;
    createdAt: string;
    status: string;
}

export interface AppUsersResponse {
    users: AppUser[];
    pagination: {
        page: number;
        limit: number;
        totalCount: number;
        totalPages: number;
    };
}

export interface GetAppUsersParams {
    token: string;
    page?: number;
    limit?: number;
    search?: string;
    type?: string;
}

export interface UpdateAppUserTypeParams {
    token: string;
    userId: string;
    type: "app" | "ADMIN";
}

export interface UpdateAppUserTypeResponse {
    user: AppUser;
}

export const getAppUsers = async ({
    token,
    page = 1,
    limit = 15,
    search,
    type,
}: GetAppUsersParams): Promise<AppUsersResponse> => {
    return fetchAPI<AppUsersResponse>("/get-app-users", "POST", { page, limit, search, type }, token);
};

export const updateAppUserType = async ({
    token,
    userId,
    type,
}: UpdateAppUserTypeParams): Promise<UpdateAppUserTypeResponse> => {
    return fetchAPI<UpdateAppUserTypeResponse>("/update-app-user-type", "POST", { userId, type }, token);
};
